import {majorToMinor} from "core/format/minorUnits";
import type {OfferPrice, SuccessCardContext} from "upsell/offerEvents";
import type {CouponGift, CurrentLadderGift} from "./currentLadderOffer";
import {planCodeForId} from "pricing/planCatalogue";

/** Whitelist experiment context; the checkout capability and Stripe code never leave through events. */
export function couponEventDetails(gift: CurrentLadderGift): {context: SuccessCardContext; price: OfferPrice} {
	const {presentationId, offerKey, arm, percentOff, amountOff} = gift.offer;
	return {
		context: {presentationId, offerKey, arm, targetPlan: planCodeForId(gift.targetPlan), currency: gift.currency,
			...(percentOff === undefined ? {} : {percentOff}), ...(amountOff === undefined ? {} : {amountMinor: amountOff})},
		price: couponGiftPrice(gift),
	};
}

/** The first month a coupon's dialog quotes, in minor units: the figure its funnel steps carry. */
export function couponGiftPrice(gift: CouponGift): OfferPrice {
	return {currency: gift.currency, amountMinor: majorToMinor(gift.firstMonth, gift.currency)};
}
